import React, { Component, PropTypes } from 'react';
import Joyride from 'react-joyride';

class JoyrideWrapper extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            steps: [],
            run: false
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.addSteps(this.props.steps);
            this.setState({ run: true });
            this.joyride.start(this.props.autorun);
        }, 2000);
    }

    addSteps(steps) {
        if (!Array.isArray(steps)) {
            steps = [steps];
        }

        if (!steps.length) {
            return false;
        }

        this.setState(function (currentState) {
            currentState.steps = currentState.steps.concat(this.joyride.parseSteps(steps));
            return currentState;
        });
    }

    render() {
        return (
            <Joyride
                ref={c => (this.joyride = c)}
                steps={this.state.steps}
                type="continuous"
                run={this.state.run}
                disableOverlay
                locale={{ back: 'Back', close: 'Finish', last: 'Last', next: 'Next', skip: 'Skip' }}
                callback={this.props.callback} />
        );
    }
}

JoyrideWrapper.defaultProps = {
    autorun: true,
    callback: null
};

JoyrideWrapper.propTypes = {
    autorun: PropTypes.bool,
    steps: PropTypes.array.isRequired,
    callback: PropTypes.func
};

export default JoyrideWrapper;



/** WEBPACK FOOTER **
 ** ./src/elements/JoyrideWrapper.js
 **/